import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

function TgIcon(props: SvgIconProps) {
	return (
		<SvgIcon viewBox="0 0 20 20" {...props}>
			<rect x="0.175768" y="0.175768" width="19.6485" height="19.6485" rx="3.82423" fill="#D80067" />
			<rect
				x="0.175768"
				y="0.175768"
				width="19.6485"
				height="19.6485"
				rx="3.82423"
				stroke="#D80067"
				strokeWidth="0.351536"
				fill="#D80067"
			/>
			<g clip-path="url(#clip0_13076_5985)">
				<path
					d="M11.25 7.5H11.2563M10.625 15H6.25C5.75272 15 5.27581 14.8025 4.92417 14.4508C4.57254 14.0992 4.375 13.6223 4.375 13.125V6.875C4.375 6.37772 4.57254 5.90081 4.92417 5.54917C5.27581 5.19754 5.75272 5 6.25 5H12.5C12.9973 5 13.4742 5.19754 13.8258 5.54917C14.1775 5.90081 14.375 6.37772 14.375 6.875V8.4375M4.375 11.875L6.875 9.37501C7.455 8.81688 8.17 8.81688 8.75 9.37501L10 10.625"
					stroke="white"
					strokeWidth="0.78125"
					strokeLinecap="round"
					strokeLinejoin="round"
					fill="#D80067"
				/>
				<path
					d="M11.875 13.125C13.2557 13.125 14.375 14.2443 14.375 15.625C14.375 14.2443 15.4943 13.125 16.875 13.125C15.4943 13.125 14.375 12.0057 14.375 10.625C14.375 12.0057 13.2557 13.125 11.875 13.125Z"
					stroke="white"
					strokeWidth="0.78125"
					strokeLinecap="round"
					strokeLinejoin="round"
					fill="#D80067"
				/>
			</g>
			<defs>
				<clipPath id="clip0_13076_5985">
					<rect width="15" height="15" fill="white" transform="translate(2.5 2.5)" />
				</clipPath>
			</defs>
		</SvgIcon>
	);
}

export default TgIcon;
